import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-content',
  templateUrl: './root.component.html',
  styleUrls: ['./root.component.scss']
})
export class RootComponent implements OnInit {
  public searchValue: string = null;

  public cities: Array<any> = [
    {
      'id': '84',
      'code': 'CLA0084',
      'name': 'Clamart',
      'hasFps': '1',
      'hasRapo': '1',
      'hasFpsPaiement': '1',
      'hasFpsEhab': '1',
		  'latitude': '48.7957397',
		  'longitude': '2.2167841',
		  'codePostal': '92140',
		  'logoUrl': 'https://cla0184.epweb.pro/images/logos/CLA0184.jpg',
		  'paymentUrl': 'https://www.stationnement.gouv.fr/fps',
		  'rapoUrl': 'https://clamart.e-habitants.com/stationnement/rapo/new',
		  'rapoAdress': 'Gestion des RAPO',
		  'rapoCP': '92140',
		  'rapoVille': 'Clamart',
		  'Siret': '21920023500014',
		  'fps.cycle': 'Complet',
		  'fps.min': 'Non'
	  },
	  {
		'id': '9',
		'code': 'VIR0009',
		'name': 'Viroflay',
		'hasFps': '1',
		'hasRapo': '',
		'hasFpsPaiement': '',
		'hasFpsEhab': '',
		'latitude': '48.8017506',
		'longitude': '2.154987',
		'codePostal': '78220',
		'logoUrl': 'https://vir0009.epweb.pro/images/logos/VIR0009.jpg',
		'paymentUrl': '',
		'rapoUrl': '',
		'rapoAdress': 'Mairie de Viroflay',
		'rapoCP': '78221',
		'rapoVille': 'Viroflay Cedex',
		'Siret': '21780686800014',
		'fps.cycle': 'Complet',
		'fps.min': 'Non'
	},
	{
		'id': '10',
		'code': 'MEL0010',
		'name': 'Melun (FPS)',
		'hasFps': '1',
		'hasRapo': '',
		'hasFpsPaiement': '',
		'hasFpsEhab': '',
		'latitude': '48.5421321',
		'longitude': '2.6202101',
		'codePostal': '77000',
		'logoUrl': 'https://mel0010.epweb.pro/images/logos/MEL0010.jpg',
		'paymentUrl': '',
		'rapoUrl': '',
		'rapoAdress': 'Police Municipale - Hotel de Ville - 16 rue Paul Doumer',
		'rapoCP': '77000',
		'rapoVille': 'Melun',
		'Siret': '21770288500013',
		'fps.cycle': 'Complet',
		'fps.min': 'Non'
	},
	{
		'id': '11',
		'code': 'COM0011',
		'name': 'Compiègne',
		'hasFps': '1',
		'hasRapo': '',
		'hasFpsPaiement': '',
		'hasFpsEhab': '',
		'latitude': '49.4005793',
		'longitude': '2.7848179',
		'codePostal': '60200',
		'logoUrl': 'https://com0011.epweb.pro/images/logos/COM0011.jpg',
		'paymentUrl': '',
		'rapoUrl': '',
		'rapoAdress': 'Police Municipale Ville de Compiegne BP 30009',
		'rapoCP': '60321',
		'rapoVille': 'Compiegne Cedex',
		'Siret': '21600158600017',
		'fps.cycle': 'Partiel',
		'fps.min': 'Non'
	},
	{
		'id': '12',
		'code': 'VSM0012',
		'name': 'Villiers-sur-Marne',
		'hasFps': '1',
		'hasRapo': '',
		'hasFpsPaiement': '',
		'hasFpsEhab': '',
		'latitude': '48.8277991',
		'longitude': '2.5132042',
		'codePostal': '94350',
		'logoUrl': 'https://vsm0012.epweb.pro/images/logos/VSM0012.jpg',
		'paymentUrl': '',
		'rapoUrl': '',
		'rapoAdress': 'Mairie - Place de l\'Hotel de Ville',
		'rapoCP': '94350',
		'rapoVille': 'Villiers-sur-Marne',
		'Siret': '21940079300010',
		'fps.cycle': 'Complet',
		'fps.min': 'Non'
	},
	{
		'id': '16',
		'code': 'CHN0016',
		'name': 'Cachan',
		'hasFps': '1',
		'hasRapo': '',
		'hasFpsPaiement': '',
		'hasFpsEhab': '',
		'latitude': '48.7913847',
		'longitude': '2.3144249',
		'codePostal': '94230',
		'logoUrl': 'https://chn0016.epweb.pro/images/logos/CHN0016.jpg',
		'paymentUrl': '',
		'rapoUrl': '',
		'rapoAdress': 'Police Municipale - Hotel de ville- square de la libération',
		'rapoCP': '94239',
		'rapoVille': 'Cachan',
		'Siret': '21940016500011',
		'fps.cycle': 'Complet',
		'fps.min': 'Non'
	},
	{
		'id': '18',
		'code': 'GRD0018',
		'name': 'Guérande',
		'hasFps': '1',
		'hasRapo': '',
		'hasFpsPaiement': '1',
		'hasFpsEhab': '1',
		'latitude': '47.3232512',
		'longitude': '-2.3802119',
		'codePostal': '44350',
		'logoUrl': 'https://grd0018.epweb.pro/images/logos/GRD0018.jpg',
		'paymentUrl': 'https://guerande.e-habitants.com/fps/',
		'rapoUrl': '',
		'rapoAdress': 'Ville de Guérande - 7 place du marché au bois',
		'rapoCP': '44350',
		'rapoVille': 'Guérande',
		'Siret': '21440069900143',
		'fps.cycle': 'Complet',
		'fps.min': 'Oui'
	},
	{
		'id': '29',
		'code': 'DIE0029',
		'name': 'Saint-Dié',
		'hasFps': '1',
		'hasRapo': '',
		'hasFpsPaiement': '',
		'hasFpsEhab': '',
		'latitude': '48.887025',
		'longitude': '2.270015',
		'codePostal': '52100',
		'logoUrl': 'https://die0029.epweb.pro/images/logos/DIE0029.jpg',
		'paymentUrl': '',
		'rapoUrl': '',
		'rapoAdress': 'Police Municipale - Place de l\'Europe',
		'rapoCP': '88100',
		'rapoVille': 'Saint-Die-des-Vosges',
		'Siret': '21880413600016',
		'fps.cycle': 'Complet',
		'fps.min': 'Non'
	},
	{
		'id': '30',
		'code': 'RBX0030',
		'name': 'Roubaix',
		'hasFps': '1',
		'hasRapo': '1',
		'hasFpsPaiement': '1',
		'hasFpsEhab': '1',
		'latitude': '50.6887078',
		'longitude': '3.1492011',
		'codePostal': '59100',
		'logoUrl': 'https://rbx0030.epweb.pro/images/RBX0030/ROU0072.png',
		'paymentUrl': 'https://www.jestationnearoubaix.com/fps/',
		'rapoUrl': 'https://www.jestationnearoubaix.com/stationnement/rapo/new',
		'rapoAdress': 'Parcogest - 5 rue du curoir',
		'rapoCP': '59100',
		'rapoVille': 'Roubaix',
		'Siret': '21590512600011',
		'fps.cycle': 'Complet',
		'fps.min': 'Oui'
	},
	{
		'id': '38',
		'code': 'VER0038',
		'name': 'Versailles',
		'hasFps': '1',
		'hasRapo': '1',
		'hasFpsPaiement': '1',
		'hasFpsEhab': '1',
		'latitude': '48.8038627',
		'longitude': '2.0841591',
		'codePostal': '78000',
		'logoUrl': 'https://ver0038.epweb.pro/images/logos/VER0038.jpg',
		'paymentUrl': 'https://stationnement.versailles.fr/fps/',
		'rapoUrl': 'https://stationnement.versailles.fr/stationnement/rapo/new',
		'rapoAdress': 'Direction de la securite - 4 avenue de Paris - RP 1144',
		'rapoCP': '78011',
		'rapoVille': 'Versailles Cedex',
		'Siret': '21780646200016',
		'fps.cycle': 'Complet',
		'fps.min': 'Oui'
	},
	{
		'id': '40',
		'code': 'DIJ0040',
		'name': 'Dijon',
		'hasFps': '1',
		'hasRapo': '1',
		'hasFpsPaiement': '1',
		'hasFpsEhab': '1',
		'latitude': '47.331881',
		'longitude': '5.032221',
		'codePostal': '21000',
		'logoUrl': 'https://dij0040.epweb.pro/images/DIJ0040/DIJ0040.png',
		'paymentUrl': 'https://www.jemegare.fr/dijon/fps/',
		'rapoUrl': 'https://www.jemegare.fr/dijon/stationnement/rapo/new',
		'rapoAdress': 'DiviaPark - BP 50929',
		'rapoCP': '21009',
		'rapoVille': 'Dijon Cedex',
		'Siret': '24210041000123',
		'fps.cycle': 'Complet',
		'fps.min': 'Oui'
	},
	{
		'id': '46',
		'code': 'VAL0046',
		'name': 'Valenciennes',
		'hasFps': '1',
		'hasRapo': '1',
		'hasFpsPaiement': '',
		'hasFpsEhab': '',
		'latitude': '50.3621071',
		'longitude': '3.5141815',
		'codePostal': '59300',
		'logoUrl': 'https://val0046.epweb.pro/images/logos/VAL0046.jpg',
		'paymentUrl': '',
		'rapoUrl': '',
		'rapoAdress': 'SAEMVS - 6 rue Delsaux',
		'rapoCP': '59300',
		'rapoVille': 'Valenciennes',
		'Siret': '21590606600018',
		'fps.cycle': 'Complet',
		'fps.min': 'Non'
	},
	{
		'id': '65',
		'code': 'EVR0065',
		'name': 'Evry',
		'hasFps': '1',
		'hasRapo': '1',
		'hasFpsPaiement': '1',
		'hasFpsEhab': '1',
		'latitude': '48.6298355',
		'longitude': '2.4417726',
		'codePostal': '91000',
		'logoUrl': 'https://evr0065.epweb.pro/images/logos/EVR0065.jpg',
		'paymentUrl': 'https://stationnement.evry.fr/fps/',
		'rapoUrl': 'https://stationnement.evry.fr/stationnement/rapo/new',
		'rapoAdress': 'Police municipale - place des Droits de l\'Homme et du Citoyen',
		'rapoCP': '91011',
		'rapoVille': 'Evry Cedex',
		'Siret': '21910228200569',
		'fps.cycle': 'Complet',
		'fps.min': 'Oui'
	},
	{
		'id': '71',
		'code': 'GAR0071',
		'name': 'La Garenne Colombe',
		'hasFps': '1',
		'hasRapo': '',
		'hasFpsPaiement': '',
		'hasFpsEhab': '',
		'latitude': '48.9071095',
		'longitude': '2.243691',
		'codePostal': '92250',
		'logoUrl': 'https://gar0071.epweb.pro/images/logos/GAR0071.jpg',
		'paymentUrl': '',
		'rapoUrl': '',
		'rapoAdress': 'Police Municipale - 68 boulevard de la république',
		'rapoCP': '92250',
		'rapoVille': 'La Garenne Colombes',
		'Siret': '21920035900012',
		'fps.cycle': 'Partiel',
		'fps.min': 'Oui'
	},
	{
		'id': '80',
		'code': 'CLI0080',
		'name': 'Clichy',
		'hasFps': '1',
		'hasRapo': '1',
		'hasFpsPaiement': '1',
		'hasFpsEhab': '1',
		'latitude': '48.5421321',
		'longitude': '2.6530403',
		'codePostal': '92110',
		'logoUrl': 'https://cli0080.epweb.pro/images/logos/CLI0080.jpg',
		'paymentUrl': '',
		'rapoUrl': '',
		'rapoAdress': 'Police Municipale - 96 rue Martre',
		'rapoCP': '92110',
		'rapoVille': 'Clichy',
		'Siret': '21920024300018',
		'fps.cycle': 'Complet',
		'fps.min': 'Non'
	},
	{
		'id': '83',
		'code': 'ANG0083',
		'name': 'Angoulème',
		'hasFps': '1',
		'hasRapo': '1',
		'hasFpsPaiement': '1',
		'hasFpsEhab': '1',
		'latitude': '45.645821',
		'longitude': '0.1450395',
		'codePostal': '16000',
		'logoUrl': 'https://ang0083.epweb.pro/images/logos/ANG0083.jpg',
		'paymentUrl': 'https://stationnement-angouleme.com/',
		'rapoUrl': 'https://stationnement-angouleme.com/',
		'rapoAdress': 'Police Municipale - 8 place Bouillaud',
		'rapoCP': '16000',
		'rapoVille': 'Angoulème',
		'Siret': '21160015000018',
		'fps.cycle': 'Complet',
		'fps.min': 'Oui'
	},
	{
		'id': '93',
		'code': 'VER0093',
		'name': 'Vernon',
		'hasFps': '1',
		'hasRapo': '1',
		'hasFpsPaiement': '',
		'hasFpsEhab': '',
		'latitude': '49.097584',
		'longitude': '1.3566578',
		'codePostal': '27200',
		'logoUrl': 'https://ver0093.epweb.pro/images/logos/VER0093.jpg',
		'paymentUrl': '',
		'rapoUrl': 'https://jecontestemonfps.fr/vernon',
		'rapoAdress': 'PARKOSERVICE - Unité Vernon - Pont de falaise',
		'rapoCP': '78124',
		'rapoVille': 'Mareil-sur-Mauldre',
		'Siret': '21270681600015',
		'fps.cycle': 'Complet',
		'fps.min': 'Non'
	},
	{
		'id': '100',
		'code': 'STM0100',
		'name': 'Saint-Malo',
		'hasFps': '1',
		'hasRapo': '1',
		'hasFpsPaiement': '1',
		'hasFpsEhab': '1',
		'latitude': '48.6462819',
		'longitude': '-2.0066529',
		'codePostal': '35400',
		'logoUrl': 'https://stm0100.epweb.pro/images/logos/STM0100.jpg',
		'paymentUrl': 'https://www.jemegare.fr/saint-malo/fps/',
		'rapoUrl': 'https://www.jemegare.fr/saint-malo/stm0100/rapo',
		'rapoAdress': 'Effia Stationnement',
		'rapoCP': '37206',
		'rapoVille': 'Tours Cedex 03',
		'Siret': '21350288300019',
		'fps.cycle': 'Complet',
		'fps.min': 'Oui'
	},
	{
		'id': '109',
		'code': 'LEN0109',
		'name': 'Lens',
		'hasFps': '1',
		'hasRapo': '1',
		'hasFpsPaiement': '1',
		'hasFpsEhab': '1',
		'latitude': '50.4395206',
		'longitude': '2.7840507',
		'codePostal': '62300',
		'logoUrl': 'https://len0109.epweb.pro/images/logos/LEN0109.jpg',
		'paymentUrl': 'https://www.jemegare.fr/lens/fps/',
		'rapoUrl': 'https://www.jemegare.fr/lens/len0109/rapo',
		'rapoAdress': 'Effia Stationnement - place Du G. de Gaulle',
		'rapoCP': '62300',
		'rapoVille': 'Lens',
		'Siret': '21620498200013',
		'fps.cycle': 'Complet',
		'fps.min': 'Oui'
	},
	{
		'id': '117',
		'code': 'BEZ0117',
		'name': 'Beziers',
		'hasFps': '1',
		'hasRapo': '1',
		'hasFpsPaiement': '1',
		'hasFpsEhab': '1',
		'latitude': '43.3482155',
		'longitude': '3.1641805',
		'codePostal': '34500',
		'logoUrl': 'https://bez0117.epweb.pro/images/logos/BEZ0117.jpg',
		'paymentUrl': 'https://www.jemegare.fr/beziers/fps/',
		'rapoUrl': 'https://www.jemegare.fr/beziers/bez0077/rapo',
		'rapoAdress': 'Effia Stationnement - 50 cours de la République',
		'rapoCP': '69100',
		'rapoVille': 'Villeurbanne',
		'Siret': '21340032800018',
		'fps.cycle': 'Complet',
		'fps.min': 'Oui'
	},
	{
		'id': '118',
		'code': 'SCO0118',
		'name': 'Sceaux',
		'hasFps': '1',
		'hasRapo': '1',
		'hasFpsPaiement': '1',
		'hasFpsEhab': '1',
		'latitude': '48.7760138',
		'longitude': '2.2875042',
		'codePostal': '92330',
		'logoUrl': 'https://sco0118.epweb.pro/images/logos/SCO0118.jpg',
		'paymentUrl': 'https://www.jemegare.fr/sceaux/fps',
		'rapoUrl': 'https://www.jemegare.fr/sceaux/sco0118/rapo',
		'rapoAdress': 'Effia Stationnement - DR IDF - 20 Rue Hector Malot',
		'rapoCP': '75012',
		'rapoVille': 'Paris',
		'Siret': '21920071400018',
		'fps.cycle': 'Complet',
		'fps.min': 'Oui'
	},
	{
		'id': '123',
		'code': 'BEB0123',
		'name': 'Bourg-en-Bresse',
		'hasFps': '1',
		'hasRapo': '',
		'hasFpsPaiement': '',
		'hasFpsEhab': '',
		'latitude': '',
		'longitude': '',
		'codePostal': '1000',
		'logoUrl': 'https://beb0123.epweb.pro/images/logos/BEB0123.jpg',
		'paymentUrl': '',
		'rapoUrl': '',
		'rapoAdress': 'Ville de Bourg en Bresse - Régie Bourg Parc Auto - place de l’Hôtel de Ville – BP 90 419',
		'rapoCP': '1012',
		'rapoVille': 'Bourg-en-Bresse Cedex',
		'Siret': '21010053300012',
		'fps.cycle': 'Complet',
		'fps.min': 'Non'
	},
	{
		'id': '124',
		'code': 'BRI0124',
		'name': 'Brive-la-gaillarde',
		'hasFps': '1',
		'hasRapo': '1',
		'hasFpsPaiement': '',
		'hasFpsEhab': '',
		'latitude': '45.1454606',
		'longitude': '1.4442878',
		'codePostal': '19312',
		'logoUrl': 'https://bri0124.epweb.pro/images/logos/BRI0124.jpg',
		'paymentUrl': '',
		'rapoUrl': '',
		'rapoAdress': '1 avenue Maillard',
		'rapoCP': '19100',
		'rapoVille': 'Brive',
		'Siret': '21190310900018',
		'fps.cycle': 'Complet',
		'fps.min': 'Non'
	},
	{
		'id': '125',
		'code': 'CHA0125',
		'name': 'Chambery',
		'hasFps': '1',
		'hasRapo': '1',
		'hasFpsPaiement': '1',
		'hasFpsEhab': '1',
		'latitude': '45.5822142',
		'longitude': ' 5.871334',
		'codePostal': '73000',
		'logoUrl': 'https://cha0125.epweb.pro/images/logos/CHA0125.jpg',
		'paymentUrl': 'https://www.jemegare.fr/chambery/fps/',
		'rapoUrl': 'https://www.jemegare.fr/chambery/cha0125/rapo',
		'rapoAdress': 'EFFIA Stationnement Chambéry - 50 cours de la république',
		'rapoCP': '69100',
		'rapoVille': 'Villeurbanne',
		'Siret': '21730065600014',
		'fps.cycle': 'Complet',
		'fps.min': 'Oui'
	},
	{
		'id': '126',
		'code': 'CEC0070',
		'name': 'Châlons-en-Champagne',
		'hasFps': '1',
		'hasRapo': '1',
		'hasFpsPaiement': '1',
		'hasFpsEhab': '',
		'latitude': '48.9655528',
		'longitude': '4.3100123',
		'codePostal': '51000',
		'logoUrl': 'https://cec0070.epweb.pro/images/logos/CEC0070.jpg',
		'paymentUrl': '',
		'rapoUrl': '',
		'rapoAdress': 'Hotel de ville - Place Foch',
		'rapoCP': '51000',
		'rapoVille': 'Chalons-en-champagne',
		'Siret': '21510101500018',
		'fps.cycle': 'Complet',
		'fps.min': 'Oui'
	},
	{
		'id': '136',
		'code': 'PSG0136',
		'name': 'Pré-Saint-Gervais',
		'hasFps': '1',
		'hasRapo': '1',
		'hasFpsPaiement': '1',
		'hasFpsEhab': '1',
		'latitude': '48.8840431',
		'longitude': '2.3966707',
		'codePostal': '93310',
		'logoUrl': 'https://psg0136.epweb.pro/images/logos/PSG0136.jpg',
		'paymentUrl': 'https://pre-saint-gervais.e-habitants.com/fps/',
		'rapoUrl': 'https://pre-saint-gervais.e-habitants.com/stationnement/rapo/new',
		'rapoAdress': 'Ville du Pre Saint-Gervais - 84 bis rue Andre Joineau',
		'rapoCP': '93311',
		'rapoVille': 'LE PRE SAINT-GERVAIS',
		'Siret': '21930061300011',
		'fps.cycle': 'Complet',
		'fps.min': 'Oui'
	},
	{
		'id': '137',
		'code': 'FIG0137',
		'name': 'Figeac',
		'hasFps': '1',
		'hasRapo': '',
		'hasFpsPaiement': '',
		'hasFpsEhab': '',
		'latitude': '44.6066671',
		'longitude': '1.9530543',
		'codePostal': '46100',
		'logoUrl': 'https://fig0137.epweb.pro/images/logos/FIG0137.jpg',
		'paymentUrl': '',
		'rapoUrl': '',
		'rapoAdress': 'Mairie de Figeac - 5 Rue de Colomb',
		'rapoCP': '46100',
		'rapoVille': 'Figeac',
		'Siret': '21460102300010',
		'fps.cycle': 'Complet',
		'fps.min': 'Non'
	},
	{
		'id': '138',
		'code': 'HAG0138',
		'name': 'Hagondange',
		'hasFps': '1',
		'hasRapo': '',
		'hasFpsPaiement': '',
		'hasFpsEhab': '',
		'latitude': '49.2421572',
		'longitude': '6.0211413',
		'codePostal': '57300',
		'logoUrl': 'https://hag0138.epweb.pro/images/logos/HAG0138.jpg',
		'paymentUrl': '',
		'rapoUrl': '',
		'rapoAdress': 'Mairie de Hagondange - place Jean Burger',
		'rapoCP': '57300',
		'rapoVille': 'Hagondange',
		'Siret': '21570283800016',
		'fps.cycle': 'Complet',
		'fps.min': 'Non'
	},
	{
		'id': '139',
		'code': 'BAD0139',
		'name': 'Baden',
		'hasFps': '1',
		'hasRapo': '',
		'hasFpsPaiement': '',
		'hasFpsEhab': '',
		'latitude': '47.6058872',
		'longitude': '-2.9736232',
		'codePostal': '56870',
		'logoUrl': 'https://bad0139.epweb.pro/images/logos/BAD0139.jpg',
		'paymentUrl': '',
		'rapoUrl': '',
		'rapoAdress': 'Police Municipale - 3 place Weilheim',
		'rapoCP': '56870',
		'rapoVille': 'Baden',
		'Siret': '21560008100081',
		'fps.cycle': 'Complet',
		'fps.min': 'Non'
	},
	{
		'id': '140',
		'code': 'PTO0140',
		'name': 'Puteaux',
		'hasFps': '1',
		'hasRapo': '',
		'hasFpsPaiement': '',
		'hasFpsEhab': '',
		'latitude': '48.8823567',
		'longitude': '2.2208939',
		'codePostal': '92800',
		'logoUrl': 'https://pto0140.epweb.pro/images/logos/PTO0140.jpg',
		'paymentUrl': '',
		'rapoUrl': '',
		'rapoAdress': 'Mairie de Puteaux – Contestation FPS - 131 rue de la république',
		'rapoCP': '92800',
		'rapoVille': 'Puteaux',
		'Siret': '21920062300011',
		'fps.cycle': 'Complet',
		'fps.min': 'Non'
	},
	{
		'id': '142',
		'code': 'TLN0142',
		'name': 'Toulon (fps)',
		'hasFps': '1',
		'hasRapo': '',
		'hasFpsPaiement': '',
		'hasFpsEhab': '',
		'latitude': '43.1363397',
		'longitude': '5.8633912',
		'codePostal': '83000',
		'logoUrl': 'https://tln0142.epweb.pro/images/logos/TLN0142.jpg',
		'paymentUrl': '',
		'rapoUrl': '',
		'rapoAdress': 'Police Municipale - 1 place pasteur',
		'rapoCP': '83000',
		'rapoVille': 'Toulon',
		'Siret': '21830137200015',
		'fps.cycle': 'Complet',
		'fps.min': 'Non'
	},
	{
		'id': '143',
		'code': 'MEG0143',
		'name': 'Megeve',
		'hasFps': '1',
		'hasRapo': '',
		'hasFpsPaiement': '',
		'hasFpsEhab': '',
		'latitude': '45.8396446',
		'longitude': '6.5541066',
		'codePostal': '74120',
		'logoUrl': 'https://meg0143.epweb.pro/images/logos/MEG0143.jpg',
		'paymentUrl': '',
		'rapoUrl': '',
		'rapoAdress': 'Mairie - Police Municipale - BP23',
		'rapoCP': '74120',
		'rapoVille': 'Megeve',
		'Siret': '21740173600012',
		'fps.cycle': 'Complet',
		'fps.min': 'Oui'
	},
	{
		'id': '146',
		'code': 'MAF0146',
		'name': 'Maisons-Alfort',
		'hasFps': '1',
		'hasRapo': '',
		'hasFpsPaiement': '',
		'hasFpsEhab': '',
		'latitude': '48.8017312',
		'longitude': '2.4049302',
		'codePostal': '94700',
		'logoUrl': 'https://maf0146.epweb.pro/images/logos/MAF0146.jpg',
		'paymentUrl': '',
		'rapoUrl': '',
		'rapoAdress': 'Police Municipale - 119 avenue du General de Gaulle',
		'rapoCP': '94700',
		'rapoVille': 'Maisons-Alfort',
		'Siret': '21940046200012',
		'fps.cycle': 'Complet',
		'fps.min': 'Non'
	},
	{
		'id': '147',
		'code': 'BDP0147',
		'name': 'Baux-de-Provence',
		'hasFps': '1',
		'hasRapo': '',
		'hasFpsPaiement': '',
		'hasFpsEhab': '',
		'latitude': '43.7491352',
		'longitude': '4.7700046',
		'codePostal': '13520',
		'logoUrl': 'https://bdp0147.epweb.pro/images/logos/BDP0147.jpg',
		'paymentUrl': '',
		'rapoUrl': '',
		'rapoAdress': '29 Rue du Château',
		'rapoCP': '13520',
		'rapoVille': 'Les Baux-de-Provence',
		'Siret': '21130011600012',
		'fps.cycle': 'Complet',
		'fps.min': 'Non'
	},
	{
		'id': '148',
		'code': 'SMA0148',
		'name': 'Saint-Maurice',
		'hasFps': '1',
		'hasRapo': '1',
		'hasFpsPaiement': '1',
		'hasFpsEhab': '1',
		'latitude': '48.8184337',
		'longitude': '2.4075251',
		'codePostal': '94410',
		'logoUrl': 'https://sma0148.epweb.pro/images/logos/SMA0148.jpg',
		'paymentUrl': 'https://www.jemegare.fr/saint-maurice/fps/',
		'rapoUrl': 'https://www.jemegare.fr/saint-maurice/len0109/rapo',
		'rapoAdress': '',
		'rapoCP': '',
		'rapoVille': '',
		'Siret': '21940069400010',
		'fps.cycle': 'Complet',
		'fps.min': 'Non'
	},
	{
		'id': '149',
		'code': 'VCN0149',
		'name': 'Vincennes',
		'hasFps': '1',
		'hasRapo': '1',
		'hasFpsPaiement': '1',
		'hasFpsEhab': '1',
		'latitude': '48.8471232',
		'longitude': '2.420734',
		'codePostal': '94300',
		'logoUrl': 'https://vcn0149.epweb.pro/images/logos/VCN0149.jpg',
		'paymentUrl': 'https://www.jemegare.fr/vincennes/fps/',
		'rapoUrl': 'https://www.jemegare.fr/vincennes/vcn0149/rapo',
		'rapoAdress': 'Effia Stationnement Vincennes RAPO - 20 rue Hector Malot',
		'rapoCP': '75012',
		'rapoVille': 'Paris',
		'Siret': '21940080100011',
		'fps.cycle': 'Complet',
		'fps.min': 'Oui'
	},
	{
		'id': '151',
		'code': 'BTM0151',
		'name': 'Brantome',
		'hasFps': '1',
		'hasRapo': '',
		'hasFpsPaiement': '',
		'hasFpsEhab': '',
		'latitude': '',
		'longitude': '',
		'codePostal': '24310',
		'logoUrl': 'https://btm0151.epweb.pro/images/logos/BTM0151.jpg',
		'paymentUrl': 'https://www.stationnement.gouv.fr/fps',
		'rapoUrl': '',
		'rapoAdress': 'Mairie de Brantome en Perigord',
		'rapoCP': '24310',
		'rapoVille': 'Brantome en Perigord',
		'Siret': '20005858400018',
		'fps.cycle': 'Complet',
		'fps.min': 'Non'
	},
	{
		'id': '156',
		'code': 'BDL0156',
		'name': 'Bandol',
		'hasFps': '1',
		'hasRapo': '',
		'hasFpsPaiement': '',
		'hasFpsEhab': '',
		'latitude': '43.1470287',
		'longitude': '5.7313174',
		'codePostal': '83150',
		'logoUrl': 'https://bdl0156.epweb.pro/images/logos/BDL0156.jpg',
		'paymentUrl': '',
		'rapoUrl': '',
		'rapoAdress': 'POLICE MUNICIPALE - BP 25',
		'rapoCP': '83150',
		'rapoVille': 'Bandol',
		'Siret': '21830009300018',
		'fps.cycle': 'Complet',
		'fps.min': 'Non'
	},
	{
		'id': '159',
		'code': 'UZS159',
		'name': 'Uzes',
		'hasFps': '1',
		'hasRapo': '',
		'hasFpsPaiement': '',
		'hasFpsEhab': '',
		'latitude': '44.0288821',
		'longitude': '4.3459937',
		'codePostal': '30700',
		'logoUrl': 'https://uzs0159.epweb.pro/images/logos/UZS0159.jpg',
		'paymentUrl': '',
		'rapoUrl': 'rapo@uzes.fr',
		'rapoAdress': 'Service RAPO Mairie d’Uzès - 1 place Albert 1er BP 71103 ',
		'rapoCP': '30701',
		'rapoVille': 'Uzes',
		'Siret': '21300334600011',
		'fps.cycle': 'Complet',
		'fps.min': 'Non'
	},
	{
		'id': '161',
		'code': 'ELB0161',
		'name': 'Enghien-les-Bains',
		'hasFps': '1',
		'hasRapo': '1',
		'hasFpsPaiement': '1',
		'hasFpsEhab': '1',
		'latitude': '',
		'longitude': '',
		'codePostal': '95880',
		'logoUrl': 'https://uzs0159.epweb.pro/images/logos/ELB0161.jpg',
		'paymentUrl': '',
		'rapoUrl': '',
		'rapoAdress': '',
		'rapoCP': '',
		'rapoVille': '',
		'Siret': '',
		'fps.cycle': '',
		'fps.min': ''
	},
  {
    'id': '162',
    'code': 'CHE0188',
    'name': 'Le Chesnay-Rocquencourt',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '78150',
    'logoUrl': 'https://uzs0159.epweb.pro/images/logos/CHE0188.jpg',
    'paymentUrl': 'https://jepaiemonfps.fr/lechesnay-rocquencourt/fps/',
    'rapoUrl': 'https://jepaiemonfps.fr/lechesnay-rocquencourt/stationnement/rapo/new',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '163',
    'code': 'ALB0027',
    'name': 'Aix-les-Bains',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '73100',
    'logoUrl': 'https://uzs0159.epweb.pro/images/logos/ALB0027.jpg',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '164',
    'code': 'ASM0253',
    'name': 'Argelès-sur-Mer',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '66700',
    'logoUrl': 'https://uzs0159.epweb.pro/images/logos/ASM0253.jpg',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '165',
    'code': 'ARM0160',
    'name': 'Armentières',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '59280',
    'logoUrl': 'https://uzs0159.epweb.pro/images/logos/ARM0160.jpg',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '166',
    'code': 'ARO0250',
    'name': 'Arromanches-les-Bains',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '14117',
    'logoUrl': 'https://uzs0159.epweb.pro/images/logos/ARO0250.jpg',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '167',
    'code': 'AUR0271',
    'name': 'Aurillac',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '15000',
    'logoUrl': 'https://uzs0159.epweb.pro/images/logos/AUR0271.jpg',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '168',
    'code': 'BAY0115',
    'name': 'Bayeux',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '14400',
    'logoUrl': 'https://uzs0159.epweb.pro/images/logos/BAY0115.jpg',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '169',
    'code': 'BDX0233',
    'name': 'Bordeaux',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '33000',
    'logoUrl': '../../assets/images/logo-bordeaux.png',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '170',
    'code': 'CAH0245',
    'name': 'Cahors',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '46000',
    'logoUrl': 'https://uzs0159.epweb.pro/images/logos/CAH0245.jpg',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '171',
    'code': 'CVL0299',
    'name': 'Cavalaire-sur-Mer',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '83240',
    'logoUrl': 'https://cavalaire.xtscloud.net/images/logos/CVL0299.jpg',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '172',
    'code': 'CLS0199',
    'name': 'Châlons-sur-Saone',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '71100',
    'logoUrl': 'https://uzs0159.epweb.pro/images/logos/CLS0199.jpg',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '174',
    'code': 'DRA0034',
    'name': 'Draguignan',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '83300',
    'logoUrl': 'https://uzs0159.epweb.pro/images/logos/DRA0034.jpg',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '175',
    'code': 'ETR0234',
    'name': 'Etretat',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '76790',
    'logoUrl': 'https://uzs0159.epweb.pro/images/logos/ETR0234.jpg',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '176',
    'code': 'FOR0194',
    'name': 'Forbach',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '57600',
    'logoUrl': 'https://uzs0159.epweb.pro/images/logos/FOR0194.jpg',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '177',
    'code': 'FRJ0205',
    'name': 'Fréjus',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '83370',
    'logoUrl': 'https://uzs0159.epweb.pro/images/logos/FRJ0205.jpg',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '178',
    'code': 'KSB0288',
    'name': 'Kaysersberg',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '68240',
    'logoUrl': 'https://kaysersberg-vignoble.e-habitants.com/images/logos/KSB0288.png',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '179',
    'code': 'RSY0222',
    'name': 'La Roche sur Yon',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '85000',
    'logoUrl': 'https://uzs0159.epweb.pro/images/logos/RSY0222.jpg',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '180',
    'code': 'ROC0024',
    'name': 'La Rochelle',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '17000',
    'logoUrl': 'https://uzs0159.epweb.pro/images/logos/ROC0024.jpg',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '181',
    'code': 'LAV0013',
    'name': 'Laval',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '53000',
    'logoUrl': 'https://uzs0159.epweb.pro/images/logos/LAV0013.jpg',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '183',
    'code': 'LBN0230',
    'name': 'Libourne',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '33500',
    'logoUrl': 'https://uzs0159.epweb.pro/images/logos/LBN0230.jpg',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '184',
    'code': 'MEN0229',
    'name': 'Mende',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '48000',
    'logoUrl': 'https://uzs0159.epweb.pro/images/logos/MEN0229.jpg',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '185',
    'code': 'MLB0272',
    'name': 'Mers-les-Bains',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '80350',
    'logoUrl': 'https://uzs0159.epweb.pro/images/logos/MLB0272.jpg',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '186',
    'code': 'MIL0287',
    'name': 'Millau',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '12100',
    'logoUrl': '../../assets/images/logo-millau.png',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '187',
    'code': 'OPD0268',
    'name': 'Oppede',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '84580',
    'logoUrl': 'https://uzs0159.epweb.pro/images/logos/OPD0268.jpg',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '188',
    'code': 'POI0032',
    'name': 'Poitiers',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '86000',
    'logoUrl': 'https://uzs0159.epweb.pro/images/logos/POI0032.jpg',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '189',
    'code': 'QPR0226',
    'name': 'Quimper',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '29000',
    'logoUrl': 'https://uzs0159.epweb.pro/images/logos/QPR0226.jpg',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '190',
    'code': 'RIO0014',
    'name': 'Riom',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '63200',
    'logoUrl': 'https://uzs0159.epweb.pro/images/logos/RIO0014.jpg',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '193',
    'code': 'SMD0211',
    'name': 'Saint-Mandé',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '94160',
    'logoUrl': 'https://uzs0159.epweb.pro/images/logos/SMD0211.jpg',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '194',
    'code': 'SMX0246',
    'name': 'Saint-Maximin-La-Sainte-Baume',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '83470',
    'logoUrl': 'https://uzs0159.epweb.pro/images/logos/SMX0246.jpg',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '195',
    'code': 'SVT0219',
    'name': 'Sartrouville',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '78500',
    'logoUrl': 'https://uzs0159.epweb.pro/images/logos/SVT0219.jpg',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '196',
    'code': 'SET0090',
    'name': 'Sète',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '34200',
    'logoUrl': 'https://uzs0159.epweb.pro/images/logos/SET0090.jpg',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '197',
    'code': 'SEV0210',
    'name': 'Sèvres',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '92310',
    'logoUrl': 'https://uzs0159.epweb.pro/images/logos/SEV0210.jpg',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '198',
    'code': 'STR0113',
    'name': 'Strasbourg',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '67000',
    'logoUrl': 'https://uzs0159.epweb.pro/images/logos/STR0113.jpg',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '199',
    'code': 'TLR0254',
    'name': 'Talloires-Montmin',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '74290',
    'logoUrl': 'https://uzs0159.epweb.pro/images/logos/TLR0254.jpg',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '200',
    'code': 'TRS0237',
    'name': 'Tours',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '37000',
    'logoUrl': 'https://uzs0159.epweb.pro/images/logos/TRS0237.jpg',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '201',
    'code': 'YPT0251',
    'name': 'Yport',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '76111',
    'logoUrl': 'https://uzs0159.epweb.pro/images/logos/YPT0251.jpg',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '202',
    'code': '',
    'name': 'Ales',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '30100',
    'logoUrl': 'assets/images/logoAles.jpg',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '203',
    'code': '',
    'name': 'Arles',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '13200',
    'logoUrl': 'https://arles.xtscloud.net/images/logos/ARL0324.jpg',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '204',
    'code': '',
    'name': 'Autun',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '71400',
    'logoUrl': 'assets/images/logoAutun.png',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '205',
    'code': '',
    'name': 'Banyuls-sur-Mer',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '66650',
    'logoUrl': 'assets/images/banyulsSurMer.png',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '206',
    'code': '',
    'name': 'Besançon',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '25056',
    'logoUrl': 'assets/images/logoBesancon.png',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '207',
    'code': '',
    'name': 'Bollene',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '84500',
    'logoUrl': 'assets/images/logoBollene.jpg',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '208',
    'code': '',
    'name': 'Cannes',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '06400',
    'logoUrl': 'assets/images/logoCannes.jpg',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '209',
    'code': '',
    'name': 'Cap D\'Ail',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '06320',
    'logoUrl': 'assets/images/logoCapdAil.png',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '210',
    'code': '',
    'name': 'Carnac',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '56340',
    'logoUrl': 'assets/images/carnac.png',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '211',
    'code': '',
    'name': 'Cassis',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '13260',
    'logoUrl': 'assets/images/cassis.png',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '213',
    'code': '',
    'name': 'Chamalières',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '63400',
    'logoUrl': 'assets/images/chamalieres.png',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '214',
    'code': '',
    'name': 'Collioure',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '66190',
    'logoUrl': 'assets/images/collioure.png',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '215',
    'code': '',
    'name': 'Collonges-la-Rouge',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '19500',
    'logoUrl': 'assets/images/collongesLaRouge.jpg',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '216',
    'code': '',
    'name': 'Dinard',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '35800',
    'logoUrl': 'assets/images/dinard.png',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '217',
    'code': '',
    'name': 'Duingt',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '74410',
    'logoUrl': 'assets/images/duingt.png',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '218',
    'code': '',
    'name': 'Elbeuf',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '76500',
    'logoUrl': 'assets/images/elbeuf.jpg',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '219',
    'code': '',
    'name': 'Gap',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '05000',
    'logoUrl': 'assets/images/gap.png',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '220',
    'code': '',
    'name': 'Gravelines',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '59820',
    'logoUrl': 'assets/images/gravelines.png',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '221',
    'code': '',
    'name': 'Hendaye',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '64700',
    'logoUrl': 'https://hendaye.xtscloud.net/images/logos/HDY0311.jpg',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '222',
    'code': '',
    'name': 'Hossegor',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '40150',
    'logoUrl': 'https://hossegor.xtscloud.net/images/logos/HOS0333.jpg',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '223',
    'code': '',
    'name': 'Hyères',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '83400',
    'logoUrl': 'assets/images/hyeres.png',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '224',
    'code': '',
    'name': 'Issoire',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '63500',
    'logoUrl': 'assets/images/issoire.png',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '225',
    'code': '',
    'name': 'Lourdes',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '65100',
    'logoUrl': 'assets/images/lourdes.png',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '226',
    'code': '',
    'name': 'Maintenon',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '28130',
    'logoUrl': 'assets/images/maintenon.png',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '227',
    'code': '',
    'name': 'Mérignac',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '33700',
    'logoUrl': 'assets/images/merignac.png',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '228',
    'code': '',
    'name': 'Mont-de-Marsan',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '40192',
    'logoUrl': 'assets/images/montDeMarsan.png',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '229',
    'code': '',
    'name': 'Montbéliard',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '25200',
    'logoUrl': 'assets/images/montbeliard.jpg',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '230',
    'code': '',
    'name': 'Montfermeil',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '93047',
    'logoUrl': 'assets/images/montfermeil.png',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '231',
    'code': '',
    'name': 'Moulins',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '03000',
    'logoUrl': 'assets/images/moulins.png',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '232',
    'code': '',
    'name': 'Munster',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '68140',
    'logoUrl': 'assets/images/munster.png',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '233',
    'code': '',
    'name': 'Obernai',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '67210',
    'logoUrl': 'assets/images/obernai.png',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '234',
    'code': '',
    'name': 'Pessac',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '33600',
    'logoUrl': 'assets/images/pessac.png',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '235',
    'code': '',
    'name': 'Puy-en-Velay',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '43000',
    'logoUrl': 'assets/images/puyEnVelay.png',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '236',
    'code': '',
    'name': 'Romorantin-Lanthenay',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '41200',
    'logoUrl': 'assets/images/romorantin.png',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '237',
    'code': '',
    'name': 'Royan',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '17200',
    'logoUrl': 'assets/images/royan.png',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '238',
    'code': '',
    'name': 'Saint-Étienne',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '42000',
    'logoUrl': 'assets/images/saintEtienne.png',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '239',
    'code': '',
    'name': 'Saint-Grégoire',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '35760',
    'logoUrl': 'assets/images/saintGregoire.png',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '240',
    'code': '',
    'name': 'Saint-Guilhem-le-Désert',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '34150',
    'logoUrl': 'assets/images/saintGuilhem.jpg',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '241',
    'code': '',
    'name': 'Saint-Raphaël',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '83530',
    'logoUrl': 'assets/images/saintRaphael.png',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '242',
    'code': '',
    'name': 'Sainte-Marie-de-Ré',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '17740',
    'logoUrl': 'assets/images/sainteMarieDeRe.jpg',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '243',
    'code': '',
    'name': 'Sarlat-la-Canéda',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '24200',
    'logoUrl': 'assets/images/sarlatLaCaneda.png',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '244',
    'code': '',
    'name': 'Valence',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '26000',
    'logoUrl': 'assets/images/valence.png',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '245',
    'code': '',
    'name': 'Vence',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '06140',
    'logoUrl': 'assets/images/vence.png',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '246',
    'code': '',
    'name': 'Vesoul',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '70000',
    'logoUrl': 'assets/images/vesoul.jpg',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '247',
    'code': '',
    'name': 'Vichy',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '03200',
    'logoUrl': 'assets/images/vichy.png',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '248',
    'code': '',
    'name': 'Vitré',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '35500',
    'logoUrl': '../../assets/images/vitre.jpg',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '249',
    'code': '',
    'name': 'Urrugne',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '64122',
    'logoUrl': 'assets/images/urrugne.png',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '250',
    'code': '',
    'name': 'Fougères',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '35300',
    'logoUrl': 'assets/images/fougeres.jpg',
    'paymentUrl': 'https://my.flowbirdapp.com/embed/fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  },
  {
    'id': '251',
    'code': '',
    'name': 'Epernon',
    'hasFps': '1',
    'hasRapo': '1',
    'hasFpsPaiement': '1',
    'hasFpsEhab': '1',
    'latitude': '',
    'longitude': '',
    'codePostal': '28230',
    'logoUrl': 'assets/images/epernon.jpg',
    'paymentUrl': 'https://my.flowbirdapp.com/guest/?gwpMode=fps',
    'rapoUrl': '',
    'rapoAdress': '',
    'rapoCP': '',
    'rapoVille': '',
    'Siret': '',
    'fps.cycle': '',
    'fps.min': ''
  }
].sort((a, b) => a.name > b.name ? 1 : -1);

  constructor() { }

  ngOnInit() { }

  filterCities() {

    console.log(this.cities.filter(city => city == this.searchValue), this.searchValue);
    // Si searchValue est vide, je renvois toutes les cities.
    if ( !this.searchValue ) {
      return this.cities;
    } else {
      return this.cities.filter(city => city.name.toLowerCase().indexOf(this.searchValue.toLowerCase()) > -1 || city.codePostal.toLowerCase().indexOf(this.searchValue.toLowerCase()) > -1);
    }

  }

  openFpsPaymentPage(city) {
    if (!city.paymentUrl || city.paymentUrl.length == 0) {
      document.location.href = 'https://www.stationnement.gouv.fr/fps';
    } else {
      document.location.href = city.paymentUrl;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/root/root.component.ts